<div class="min-h-[calc(100vh-10rem)] flex items-center justify-center py-12 px-4">
  <div class="w-full max-w-md bg-white border border-gray-200 rounded-2xl shadow-lg p-8">
    <div class="mb-6 text-center">
      <h1 class="text-2xl font-bold text-gray-900">Welcome back</h1>
      <p class="text-gray-500 mt-1">Sign in to continue to Scholaris</p>
    </div>

    @if (error) {
      <app-base-alert
        type="warning"
        title="Authentication problem"
        [message]="errorMessage.detail"
        (closed)="vanishError()"
      ></app-base-alert>
    }

    <form [formGroup]="loginForm" (ngSubmit)="loginUser()" class="space-y-4">
      <div>
        <label for="inputUsername" class="block text-sm font-medium text-gray-700 mb-1"
          >Email</label
        >
        <input
          id="inputUsername"
          type="email"
          name="username"
          formControlName="username"
          placeholder="Enter email"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        @if (submitted && loginForm.controls.username.errors?.required) {
          <small class="text-sm text-yellow-700">Email is required.</small>
        }
        @if (submitted && loginForm.controls.username.errors?.email) {
          <small class="text-sm text-yellow-700">Please enter a valid email address.</small>
        }
      </div>

      <div>
        <label for="password" class="block text-sm font-medium text-gray-700 mb-1">Password</label>
        <input
          id="password"
          type="password"
          name="password"
          formControlName="password"
          placeholder="Enter password"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        @if (submitted && loginForm.controls.password.errors?.required) {
          <small class="text-sm text-yellow-700">Password is required.</small>
        }
        @if (submitted && loginForm.controls.password.errors?.minlength) {
          <small class="text-sm text-yellow-700">Password must be at least 8 characters.</small>
        }
      </div>

      <button
        type="submit"
        class="w-full py-2.5 bg-primary text-white font-semibold rounded-md hover:bg-blue-700 transition-colors"
      >
        Log in
      </button>
    </form>

    <div class="text-center">
      <p class="mt-5 text-sm text-center text-gray-600">
        No account yet?
        <a routerLink="/register" class="text-blue-600 hover:text-blue-700 font-semibold"
          >Create one</a
        >
      </p>
    </div>

    <div class="text-center">
      <a
        routerLink="/forgot-password"
        class="mt-3 inline-block text-sm text-blue-600 hover:text-blue-700 font-semibold"
      >
        Forgot password?
      </a>
    </div>

    @if (showSuperAdminSetupLink) {
      <div class="text-center">
        <p class="mt-3 text-sm text-center text-gray-600">
          Setting up a new environment?
          <a routerLink="/admin/setup" class="text-blue-600 hover:text-blue-700 font-semibold"
            >Create Super Admin</a
          >
        </p>
      </div>
    }
  </div>
</div>
